/**
 * Main Configuration of the Vue-Form-Builder
 * @author Phat Tran
 */

const MAIN_CONSTANTS = {
    COPYRIGHT: "Vue-Form-Builder v2.1.1 - github.com/sethsandaru with Love <3",
}

export {
    MAIN_CONSTANTS
}